// ISC License
// Copyright (c) for portions of Lucide are held by Cole Bemis 2013-2023 as part of Feather (MIT). All other copyright (c) for Lucide are held by Lucide Contributors 2025.
// Permission to use, copy, modify, and/or distribute this software for any purpose with or without fee is hereby granted, provided that the above copyright notice and this permission notice appear in all copies.
// THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.

import { ChevronDown } from 'lucide-react';
import CustomScrollLink from './CustomScrollLink';
import logo from 'url:./../logo_main.png';

const Hero = ({ id }) => {
    return (

        <section
            id={id}
            className="relative min-h-[80vh] md:min-h-[90vh] flex items-center justify-center overflow-hidden bg-[#1B5125] py-12 md:py-20" 
        >

            <style>
                {`
                    @keyframes fadeInUp {
                        from { opacity: 0; transform: translateY(20px); }
                        to { opacity: 1; transform: translateY(0); }
                    }
                    .animate-fadeInUp {
                        animation: fadeInUp 0.8s ease-out forwards;
                    }
                `}
            </style>

            <div className="text-center p-6 max-w-4xl relative z-10 flex flex-col items-center">
                <img
                    src={logo}
                    alt="Logo Kancelarii Adwokackiej Olga Fedyszyn-Olszewska"
                    className="max-h-[50vh] sm:max-h-[400px] lg:max-h-[500px] h-auto w-auto max-w-full mx-auto animate-fadeInUp mb-6"
                    style={{ animationDelay: '0.1s' }}
                />
            </div>

            <CustomScrollLink
                toId="about"
                className="hidden sm:block absolute bottom-10 inset-x-0 mx-auto w-fit text-white hover:text-[#1B5125] transition-colors duration-300 animate-bounce"
            >
                <ChevronDown className="h-8 w-8" />
            </CustomScrollLink>
        </section>
    );
};

export default Hero;
